"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _designSystem = require("@storybook/design-system");

var _Footer = require("./Footer.styles");

var _Services = require("./Services");

var _MailingList = require("../MailingList");

var _linksContext = require("../links-context");

var _excluded = ["onSubscribe", "subscriberCount", "inverse"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var footerGroups = function footerGroups(links) {
  return {
    why: [{
      label: 'Why Storybook',
      link: links.whyStorybook
    }, {
      label: 'Component-driven UI',
      link: links.componentDriven
    }],
    docs: [{
      label: 'Guides',
      link: links.guides
    }, {
      label: 'Tutorials',
      link: links.tutorials
    }, {
      label: 'Changelog',
      link: links.changelog
    }, {
      label: 'Telemetry',
      link: links.telemetry
    }],
    community: [{
      label: 'Addons',
      link: links.integrations
    }, {
      label: 'Get involved',
      link: links.getInvolved
    }, {
      label: 'Blog',
      link: links.blog
    }],
    showcase: [{
      label: 'Explore',
      link: links.showcase
    }, {
      label: 'Projects',
      link: links.projects
    }, {
      label: 'Component glossary',
      link: links.componentGlossary
    }]
  };
};

var Footer = function Footer(_ref) {
  var onSubscribe = _ref.onSubscribe,
      subscriberCount = _ref.subscriberCount,
      inverse = _ref.inverse,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var links = (0, _react.useContext)(_linksContext.LinksContext);
  var footerGroupsWithLinks = (0, _react.useMemo)(function () {
    return footerGroups(links);
  }, [links]);
  return /*#__PURE__*/_react["default"].createElement(_Footer.FooterWrapper, (0, _extends2["default"])({
    inverse: inverse
  }, props), /*#__PURE__*/_react["default"].createElement(_Footer.Upper, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Footer.Title, null, "Join the community"), /*#__PURE__*/_react["default"].createElement(_Footer.Subscribe, null, /*#__PURE__*/_react["default"].createElement(_MailingList.MailingListSignup, {
    onSubscribe: onSubscribe
  }), /*#__PURE__*/_react["default"].createElement(_MailingList.MailingListSubscriberCount, {
    inverse: inverse,
    count: subscriberCount
  }))), /*#__PURE__*/_react["default"].createElement(_Footer.SocialLinks, null, /*#__PURE__*/_react["default"].createElement(_Footer.IconLink, {
    appearance: inverse ? 'inverseOutline' : 'outline',
    href: "http://github.com/storybookjs"
  }, /*#__PURE__*/_react["default"].createElement(_designSystem.Icon, {
    "aria-label": "Github",
    icon: "github"
  })), /*#__PURE__*/_react["default"].createElement(_Footer.IconLink, {
    appearance: inverse ? 'inverseOutline' : 'outline',
    href: "https://twitter.com/storybookjs"
  }, /*#__PURE__*/_react["default"].createElement(_designSystem.Icon, {
    "aria-label": "Twitter",
    icon: "twitter"
  })), /*#__PURE__*/_react["default"].createElement(_Footer.IconLink, {
    appearance: inverse ? 'inverseOutline' : 'outline',
    href: "https://discord.gg/storybook"
  }, /*#__PURE__*/_react["default"].createElement(_designSystem.Icon, {
    "aria-label": "Discord",
    icon: "discord"
  })), /*#__PURE__*/_react["default"].createElement(_Footer.IconLink, {
    appearance: inverse ? 'inverseOutline' : 'outline',
    href: "https://www.youtube.com/channel/UCr7Quur3eIyA_oe8FNYexfg"
  }, /*#__PURE__*/_react["default"].createElement(_designSystem.Icon, {
    "aria-label": "YouTube",
    icon: "youtube"
  })))), /*#__PURE__*/_react["default"].createElement(_Footer.Lower, null, /*#__PURE__*/_react["default"].createElement(_Footer.Column, null, /*#__PURE__*/_react["default"].createElement(_Footer.Title, null, "Why"), footerGroupsWithLinks.why.map(function (_ref2) {
    var label = _ref2.label,
        link = _ref2.link;
    return /*#__PURE__*/_react["default"].createElement(_Footer.FooterLink, {
      key: label,
      inverse: inverse,
      tertiary: true,
      href: link.url,
      LinkWrapper: link.linkWrapper
    }, label);
  })), /*#__PURE__*/_react["default"].createElement(_Footer.Column, null, /*#__PURE__*/_react["default"].createElement(_Footer.Title, null, "Docs"), footerGroupsWithLinks.docs.map(function (_ref3) {
    var label = _ref3.label,
        link = _ref3.link;
    return /*#__PURE__*/_react["default"].createElement(_Footer.FooterLink, {
      key: label,
      inverse: inverse,
      tertiary: true,
      href: link.url,
      LinkWrapper: link.linkWrapper
    }, label);
  })), /*#__PURE__*/_react["default"].createElement(_Footer.Column, null, /*#__PURE__*/_react["default"].createElement(_Footer.Title, null, "Community"), footerGroupsWithLinks.community.map(function (_ref4) {
    var label = _ref4.label,
        link = _ref4.link;
    return /*#__PURE__*/_react["default"].createElement(_Footer.FooterLink, {
      key: label,
      inverse: inverse,
      tertiary: true,
      href: link.url,
      LinkWrapper: link.linkWrapper
    }, label);
  })), /*#__PURE__*/_react["default"].createElement(_Footer.Column, null, /*#__PURE__*/_react["default"].createElement(_Footer.Title, null, "Showcase"), footerGroupsWithLinks.showcase.map(function (_ref5) {
    var label = _ref5.label,
        link = _ref5.link;
    return /*#__PURE__*/_react["default"].createElement(_Footer.FooterLink, {
      key: label,
      inverse: inverse,
      tertiary: true,
      href: link.url,
      LinkWrapper: link.linkWrapper
    }, label);
  }))), /*#__PURE__*/_react["default"].createElement(_Services.Services, {
    inverse: inverse
  }));
};

exports.Footer = Footer;